import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import './ZoomLevel.scss';
export function ZoomLevel(props) {
    return (_jsx("button", { className: classNames({
            'sg-zoomLevel': true,
            'sg-zoomLevel-isActive': props.isActive,
        }), type: 'button', title: `Úroveň přiblížení: ${props.tooltip}`, onClick: props.onClick, children: props.children }));
}
//# sourceMappingURL=ZoomLevel.js.map